//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  Action,
  ActionBase,
  Divider,
  IconDiamond,
  IconInfo,
  IconLeaf,
  IconListview2,
  IconLock,
  IconMoney,
  IconPromo,
  Illustration,
  Paper,
  Popover,
  Tooltip,
  Typography,
  openModal,
} from '@backmarket/design-system'
import { mapGetters } from 'vuex'

import { PriceOriginal, Prices } from '@app/components/prices'
import { COUNTRIES, MODAL_NAMES } from '@config/constants'
import Carrier from '@product/components/Carrier'
import productTranslations from '@product/pages/product.translations'
import WarrantyModal from '@reassurance/components/WarrantyModal'
import { setRecommendationDebugExtension } from '@recommendation/helpers'
import { PRODUCT_SOURCE_TYPE, saveProductInfos } from '@tracking'
import { trackProductClick } from '@tracking/events'

import { HIDE_DISCOUNT_LABEL } from './Hero.config'
import translations from './Hero.translations'

export const COUNTRIES_WITH_EXTENDED_DISPLAY = [COUNTRIES.FR]

export default {
  components: {
    Action,
    IconInfo,
    IconListview2,
    IconLeaf,
    IconDiamond,
    IconMoney,
    Paper,
    Popover,
    Tooltip,
    Prices,
    WarrantyModal,
    Carrier,
    IconLock,
    ActionBase,
    Illustration,
    Typography,
    Divider,
    PriceOriginal,
    IconPromo,
  },
  props: {
    // Name of the block, used for tracking purpose
    trackingIdentifier: {
      type: String,
      default: PRODUCT_SOURCE_TYPE.HERO,
    },
    hero: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    translations: () => translations,
    productTranslations: () => productTranslations,
    ...mapGetters({
      country: 'config/country',
      showCarrier: 'config/showCarrier',
      landingHeroTracking: 'landing/heroTracking',
      currency: 'config/currencyCode',
    }),
    modalWarrantyName: () => MODAL_NAMES.REASSURANCE.WARRANTY,
    openModal: () => openModal,

    isCarrier() {
      return (
        this.showCarrier &&
        this.hero &&
        this.hero.compatible_carriers &&
        this.hero.compatible_carriers.length > 0
      )
    },

    link() {
      return this.hero.link
    },

    hasExtendedDisplay() {
      return COUNTRIES_WITH_EXTENDED_DISPLAY.includes(this.country)
    },

    originalPriceDisplay() {
      return this.hasExtendedDisplay
        ? this.$t(translations.originalPriceDisplay, {
            price: this.hero.price_original_with_currency,
          })
        : this.hero.price_original_with_currency
    },

    hasDiscount() {
      const isDiscountLabelActivated = !HIDE_DISCOUNT_LABEL[this.country]

      return this.hero.discount > 0 && isDiscountLabelActivated
    },
  },
  mounted() {
    if (this.hero.recommendation_id) {
      setRecommendationDebugExtension(this.hero.recommendation_id)
    }
  },
  methods: {
    onClick() {
      saveProductInfos({
        id: this.hero.product_id,
        price: this.hero.price_original,
        source: this.trackingIdentifier,
      })

      trackProductClick({
        list: PRODUCT_SOURCE_TYPE.LP_HERO,
        product: this.landingHeroTracking,
        widgetId: this.hero.widget_id,
      })
    },
  },
}
